import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbNavigation = ({ customBreadcrumbs = null }) => {
  const location = useLocation();

  const routeLabels = {
    '/erp/dashboard-overview': 'Dashboard',
    '/erp/applicant-tracking-system': 'Applicant Tracking System',
    '/erp/employee-management': 'Employee Management',
    '/erp/payroll-management': 'Payroll Management',
    '/erp/attendance-management': 'Attendance Management',
    '/erp/attendance-tracker': 'Attendance Tracker',
    '/erp/live-attendance': 'Live Attendance',
    '/erp/invoice-billing-management': 'Invoice & Billing Management',
    '/erp/compliance-statutory-reports': 'Compliance & Statutory Reports',
    '/erp/login-authentication': 'Login'
  };

  const generateBreadcrumbs = () => {
    if (customBreadcrumbs) {
      return customBreadcrumbs;
    }

    const pathSegments = location.pathname.split('/').filter(segment => segment);
    const breadcrumbs = [
      { label: 'Home', path: '/erp/dashboard-overview', icon: 'Home' }
    ];

    let currentPath = '';
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      const label = routeLabels[currentPath] || segment.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());

      breadcrumbs.push({
        label,
        path: currentPath,
        isLast: index === pathSegments.length - 1
      });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs.length <= 1) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-1 text-sm text-muted-foreground mb-6" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-1">
        {breadcrumbs.map((breadcrumb, index) => (
          <li key={`${breadcrumb.path}-${index}`} className="flex items-center">
            {index > 0 && (
              <Icon name="ChevronRight" size={16} className="mx-2 text-muted-foreground/60" />
            )}

            {breadcrumb.isLast ? (
              <span className="flex items-center gap-2 text-foreground font-medium">
                {breadcrumb.icon && <Icon name={breadcrumb.icon} size={16} />}
                {breadcrumb.label}
              </span>
            ) : (
              <Link
                to={breadcrumb.path}
                className="flex items-center gap-2 hover:text-foreground transition-colors duration-200"
              >
                {breadcrumb.icon && <Icon name={breadcrumb.icon} size={16} />}
                {breadcrumb.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default BreadcrumbNavigation;